export const getADAPersonComponent = (document: Document): Element | null =>
  (document && document.getElementById('ada-entry')) || null

export const isADAChatAvailable = (document: Document) =>
  getADAPersonComponent(document) ? true : false

export const getADAChatContainer = (document: Document) =>
  getADAPersonComponent(document)?.childNodes[0] as HTMLElement | null
